import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Alert,
  Card,
  CardContent,
  Grid,
  CircularProgress
} from '@mui/material';
import {
  Settings
} from '@mui/icons-material';
import { configAPI } from '../services/api';

const SettingsPage = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    try {
      setLoading(true);
      const response = await configAPI.get();
      setConfig(response.data);
    } catch (error) {
      console.error('Ошибка загрузки конфигурации:', error);
      setError('Ошибка загрузки конфигурации');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Settings color="primary" />
        Настройки системы
      </Typography>
      
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Grid container spacing={3}>
        {/* Общие настройки системы */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Общие настройки
              </Typography>
              <Alert severity="info" sx={{ mb: 2 }}>
                <Typography variant="body2">
                  <strong>Настройки плеера</strong> теперь управляются на уровне каждого приложения. 
                  Перейдите в раздел <strong>"Приложения"</strong> для настройки типов плеера.
                </Typography>
              </Alert>
              
              <Typography variant="body2" color="text.secondary">
                Здесь будут добавлены другие общие настройки системы в будущих обновлениях.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Текущая конфигурация */}
        {config && (
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Текущая конфигурация каналов
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Индивидуальные настройки для каждого канала
                </Typography>
                
                <Box sx={{ maxHeight: 300, overflow: 'auto' }}>
                  {Object.entries(config.player_type).map(([channel, type]) => (
                    channel && (
                      <Box key={channel} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1 }}>
                        <Typography variant="body2">{channel}</Typography>
                        <Typography variant="body2" color="primary">{type}</Typography>
                      </Box>
                    )
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        )}


      </Grid>
    </Box>
  );
};

export default SettingsPage;
